// apps/vrw-cp - ミッションリダイレクトページ
import React, { useEffect } from "react";
import { GetStaticProps } from "next";
import { useRouter } from "next/router";

/**
 * 空のページをISRで生成し、クライアント側でリダイレクトする
 */
export const getStaticProps: GetStaticProps = async () => {
  return { props: {}, revalidate: 60 };
};

const App = () => {
  const router = useRouter();
  useEffect(() => {
    const { pk } = router.query;
    if (typeof pk === "string") {
      // pkが文字列なら目的のページへリダイレクト
      router.replace(`/q/mission/i/${pk}`);
    }
  }, [router]);
  return <div>redirecting...</div>;
};

export default App;
